<app-window [visible]="isVisible" title="{{'importMangas' | transloco}}" [width]="'500px'" [height]="'400px'"
  position="center" [showClose]="true" [closeDisabled]="filesProcessing" [showHide]="false" [showTransparency]="false"
  (close)="onWindowClose()">

  <div class="molv-container">

    <!-- selection mode -->
    <div class="molv-mode-switch">
      <button class="molv-btn molv-btn-orange molv-mode-btn" [class.active]="!isMultiMode()"
        title="{{'uploadSingleChapter' | transloco}}" [disabled]="filesProcessing" (click)="selectSingleMode()">
        {{'single' | transloco}}
      </button>

      <button class="molv-btn molv-btn-pink molv-mode-btn" [class.active]="isMultiMode()"
        title="{{'uploadMultipleChapters' | transloco}}" [disabled]="filesProcessing" (click)="selectMultiMode()">
        {{'multi' | transloco}}
      </button>
    </div>

    <!-- form -->
    <input type="text" class="molv-txtbx" placeholder="{{'mangaName' | transloco}}" [(ngModel)]="fileName"
      [disabled]="filesProcessing">

 <button class="molv-btn molv-btn-pink" (click)="saveAndClose()"
      [disabled]="filesProcessing || (!fileName && !(isMultiMode() && uploader.items().length === 0))">
        {{ (isMultiMode() && uploader.items().length === 0) ? ('create' | transloco) : ('save' | transloco) }}
     </button>

    <molv-drop-uploader #uploader [visible]="isVisible" [saveAll$]="saveAll$" [clearAll$]="clearAll$"
      [enableMangaStructureMetadata]="isMultiMode()" [disabled]="uploaderDisabled()"
      (onDropFinished)="onUploadFinished()" (filesProcessing)="filesProcessing = $event"
      (fileSelected)="fileName = fileName ?? $event">
    </molv-drop-uploader>

  </div>
</app-window>